"use client";

import { resolveText } from "./binding";
import { MACARON } from "./tokens";
import type { MacaronRenderContext, RecordAny } from "./types";

function sizePx(size?: string): { dimension: number | null; radius: number } {
  switch (size) {
    case "small":
      return { dimension: 40, radius: 8 };
    case "large":
      return { dimension: 120, radius: 16 };
    case "full":
      return { dimension: null, radius: 16 };
    default:
      return { dimension: 80, radius: 12 };
  }
}

export function MacaronImage({ config, ctx }: { config: RecordAny; ctx: MacaronRenderContext }) {
  const url = resolveText(config.url, ctx.data);
  const { dimension, radius } = sizePx(typeof config.size === "string" ? config.size : undefined);
  if (!url) return null;

  const img = (
    <img
      src={url}
      alt=""
      className="h-full w-full object-cover"
      style={{ borderRadius: radius }}
    />
  );

  if (dimension == null) {
    return (
      <div
        className="aspect-square w-full overflow-hidden border"
        style={{ borderColor: MACARON.imageBorder, borderRadius: radius }}
      >
        {img}
      </div>
    );
  }

  return (
    <div
      className="overflow-hidden border"
      style={{
        width: dimension,
        height: dimension,
        borderColor: MACARON.imageBorder,
        borderRadius: radius,
      }}
    >
      {img}
    </div>
  );
}
